import React from "react";
import { Route, Routes } from "react-router-dom";
import { AuthProvider } from "./auth/AuthContext";
import Callback from "./auth/Callback";
import MockAuthBanner from "./auth/MockAuthBanner";
import ProtectedRoute from "./auth/ProtectedRoute";
import Home from "./pages/Home";
import Library from "./pages/Library";
import Profile from "./pages/Profile";
import VideoDetail from "./pages/VideoDetail";

export default function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/auth/callback" element={<Callback />} />
        <Route
          path="/library"
          element={
            <ProtectedRoute>
              <Library />
            </ProtectedRoute>
          }
        />
        <Route
          path="/library/:videoId"
          element={
            <ProtectedRoute>
              <VideoDetail />
            </ProtectedRoute>
          }
        />
        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              <Profile />
            </ProtectedRoute>
          }
        />
      </Routes>
      <MockAuthBanner />
    </AuthProvider>
  );
}
